module.exports = __webpack_public_path__ + "img/7.f08644ea.jpg";